import angular from 'angular';
import helloBookAttachments from './helloBookAttachments';
import './style.scss';

export default angular
  .module('helloBook.component.helloBookAttachments', [])
  .component('helloBookAttachments', helloBookAttachments).name;
